export function sortScenarioVideos(videos, sort = 'recommended') {
  switch (sort) {
    case 'recommended':
    case 'latest':
      return [...videos].sort(compareVideoLatest)
    case 'popular':
      return [...videos].sort((a, b) => b.play_count - a.play_count || compareVideoLatest(a, b))
    default:
      throw new Error(`Unhandled video sort: ${sort}`)
  }
}

export function videoCenterHref(scenarioId, videoId = '', seasonId = '') {
  const params = new URLSearchParams()
  if (scenarioId) params.set('scenarioId', scenarioId)
  if (videoId) params.set('videoId', videoId)
  if (seasonId) params.set('seasonId', seasonId)
  const query = params.toString()
  return query ? `/video-center.html?${query}` : '/video-center.html'
}

export function mobileVideoHref(videoId, returnTo = '') {
  const params = new URLSearchParams({ videoId })
  if (returnTo !== '') params.set('returnTo', returnTo)
  return `/my-videos/watch?${params.toString()}`
}

export function videoSeriesHref(scenarioId, seriesId, videoId = '', seasonId = '') {
  const params = new URLSearchParams({ scenarioId, seriesId })
  if (videoId) params.set('videoId', videoId)
  if (seasonId) params.set('seasonId', seasonId)
  return `/video-center.html?${params.toString()}`
}

export function recommendedVideoForScenario() {
  return null
}

function compareVideoLatest(a, b) {
  return videoTimestamp(b) - videoTimestamp(a)
}

function videoTimestamp(video) {
  const value = video.completed_at || video.created_at || ''
  const timestamp = Date.parse(value)
  return Number.isFinite(timestamp) ? timestamp : 0
}
